var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"oeamtc-choice oeamtc-choice--switch",attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }